const LOGIN = 'login'
const MAIN = 'main'
const TRANSACTION = 'transaction'
const HISTORY = 'history'
const ANALYTIC = 'analytic'
const MERCHANT = 'merchant'
const DEVICE = 'device'
const BANK = 'bank'
const PAYMENT_TERMINAL = "payment-terminal"
const SETTING = 'setting'
const CUSTOMER = 'customer'
const LOCATION = 'location'
const PERMISSION = "permission"

export {
    LOGIN,
    MAIN,
    TRANSACTION,
    HISTORY,
    ANALYTIC,
    MERCHANT,
    DEVICE,
    BANK,
    PAYMENT_TERMINAL,
    SETTING,
    CUSTOMER,
    LOCATION, 
    PERMISSION
}